import { keying_ar_commercial, keying_py_consummer, keying_py_comercial } from './../../../constant/shared/keying-altaEntidad';
import { keyingAll } from 'src/app/constant/shared/keying-altaEntidad/keying_all';
import { Country } from './../../../entities/shared/Country';
import { Menu } from './../../../entities/shared/Menu';
import { OptionAbmMenu } from './../../../enums/shared/menu-home.enum';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BehaviorSubject, firstValueFrom, Observable, of, throwError, TimeoutError } from 'rxjs';
import { catchError, first, map, retry, timeout } from 'rxjs/operators';
import { Persona } from 'src/app/entities/shared/Persona';
import { environment } from 'src/environments/environment';
import { Token, GenerateTokenService } from 'integrationpingid-lib';
import { NotificationService } from '../notification/notification.service';
import { NavBar } from 'src/app/entities/shared/NavBar';
import { SharedService } from 'src/app/services/shared/shared.service';
import { BuscadorService } from '../buscador/buscador.service';
import { GfdService } from '../gfd/gfd.service';
import { RdsService } from '../../api/rds/rds.service';
import { PersistenciaService } from "src/app/services/shared/persistencia-movimientos/persistencia.service";
import { DisService } from '../../api/dis/dis.service';
import COUNTRIES from 'src/assets/data/shared/COUNTRIES.json';

@Injectable({
  providedIn: 'root'
})
export class FuenteDinamicaService {
  currentPersona: Persona;
  searcherNavBar: NavBar;
  fecOperaciones: Date = new Date();
  serviceName = "FuenteDinamicaService";

  tipoServicioBack: string = "";
  // serviceMenu: string = "";
  keyingGkl: any;
  keyingGklBackup: any;
  dominioSubDominioDISGKL: string = "";
  filtrosMatchKey: any = "";

  private readonly _navBarSearch$: BehaviorSubject<NavBar> = new BehaviorSubject(null);
  filteredData: any[];

  get navBarSearch(): NavBar {
    return this._navBarSearch$.getValue();
  }

  set setnavBarSearch(show: NavBar) {
    this._navBarSearch$.next(show);
  }

  get regionSeleccionada(): Country {
    return this.localStorageService?.getRegionSeleccionada;
  }

  get urlBaseApi() {
    return (this.localStorageService.getIsVip)
      ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
  }

  get isRDS(): boolean {
    return this.localStorageService.isMenuRds();
  }

  // objetos demos de para conocer comportamiento, no se ocupan
  vinculacionList = [
    { code: 'ADI', description: 'Adicional' },
    { code: 'AVA', description: 'Avalista' },
    { code: 'COD', description: 'Codeudor' },
    { code: 'GAR', description: 'Garante' },
    { code: 'TIT', description: 'Titular' },
  ];
  esPublicaList = [
    { code: false, description: 'No' },
    { code: true, description: 'Si' },
  ];

  //parametros de entrada a busqueda de data dinamica
  paramSourceJoFull: string = "";
  paramRoute: string = "";
  paramCurrentCountry: string = "";
  paramServiceMenu: string = "";
  paramTypeSearch: string = "";
  paramDominioSubDominioGKL: string = "";
  paramBaseUrlfuente: string = "";

  // Cache de profiles de región (prioridad 2)
  private regionProfilesCache: { [region: string]: any } = {};
  private regionProfilesInFlight: { [region: string]: Promise<any> } = {};

  constructor(
    private http: HttpClient,
    public serviceToken: GenerateTokenService,
    private router: Router,
    private notificationService: NotificationService,
    private sharedService: SharedService,
    private localStorageService: LocalStorageService,
    private buscadorService: BuscadorService,
    private gfdService: GfdService,
    private rdsService: RdsService,
    private persistenciaService: PersistenciaService,
    private disService: DisService
  ) { }

  // DEFINITION "VARIABLES CATEGORICAS"
  getVinculacionList() {
    return this.vinculacionList;
  }

  getEsPublicaList() {
    return this.esPublicaList;
  }

  getTokenToHeaders() {
    let headerDict: { Authorization: string; };
    if (this.localStorageService.getIsVip) {
      headerDict = {
        Authorization: "Bearer " + localStorage.getItem('access_token')
      };
    } else {
      let token: Token = {};
      if (this.serviceToken.statusTokenUser()) {
        token = this.serviceToken.getTokenUser();
      } else {
        // This is intentional
      }
      headerDict = {
        Authorization: token.token_type + " " + token.access_token,
      };
    }
    return headerDict;
  }

  /**
   * Obtiene los profiles de región desde el servicio (prioridad 2)
   * Los cachea para evitar llamadas repetidas
   * Retorna el objeto mapeado al formato interno: {ingestaConsumer, ingestaCommercial, editionConsumer, editionCommercial}
   */
  async getRegionProfiles(region: string): Promise<any> {
    // Si ya están en cache, retornarlos
    if (this.regionProfilesCache[region]) {
      return this.regionProfilesCache[region];
    }

    // Si ya hay una petición en vuelo para esta región, reusar la misma Promise
    if (this.regionProfilesInFlight[region]) {
      return this.regionProfilesInFlight[region];
    }

    // Crear la petición y guardarla como "en vuelo"
    this.regionProfilesInFlight[region] = this.fetchRegionProfiles(region);

    try {
      const result = await this.regionProfilesInFlight[region];
      return result;
    } finally {
      delete this.regionProfilesInFlight[region];
    }
  }

  private async fetchRegionProfiles(region: string): Promise<any> {
    try {
      const objParams = { headers: this.getTokenToHeaders() };
      const isVip = this.localStorageService.getIsVip;
      const urlBaseApi = isVip
        ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
        : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];

      let url: string;
      if (isVip) {
        url = `${urlBaseApi}/vip/gcp-service/v1/profiles/${region.toUpperCase()}`;
      } else {
        const rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
          ? this.localStorageService.configInit["F_URL_MS_IM_GCP"]
          : "gcp-service";
        const microservicioPath = rutaMicroservicio ? `/${rutaMicroservicio}` : "/gcp-service";
        url = `${urlBaseApi}${microservicioPath}/api/v1/profiles/${region.toUpperCase()}`;
      }

      const response = await firstValueFrom(
        this.http.get<any>(url, objParams).pipe(
          timeout(Number(environment.HTTP_REQUEST_TIMEOUT)),
          catchError(error => {
            if (error.status === 404) {
              console.log(`[KEYING] No hay profiles de región configurados para ${region}`);
              return of(null);
            }
            console.error(`[KEYING] Error al obtener profiles de región para ${region}:`, error);
            return of(null);
          })
        )
      );

      if (response) {
        const mappedProfiles = {
          ingestaConsumer: response?.consumer?.ingesta || '',
          ingestaCommercial: response?.commercial?.ingesta || '',
          editionConsumer: response?.consumer?.edition || '',
          editionCommercial: response?.commercial?.edition || ''
        };
        this.regionProfilesCache[region] = mappedProfiles;
        return mappedProfiles;
      }

      this.regionProfilesCache[region] = null;
      return null;
    } catch (error) {
      console.error(`[KEYING] Error al obtener profiles de región para ${region}:`, error);
      return null;
    }
  }

  /**
   * Limpia el cache de profiles de región
   * Útil cuando se actualizan los profiles
   */
  clearRegionProfilesCache(region?: string) {
    if (region) {
      delete this.regionProfilesCache[region];
      delete this.regionProfilesInFlight[region];
    } else {
      this.regionProfilesCache = {};
      this.regionProfilesInFlight = {};
    }
  }

  getCurrentPerson() {
    this.localStorageService.getPersonaSelectedObs.pipe(first()).subscribe(p => {
      if (p == null) {
        // this is intentional
      } else {
        if (p) {
          this.currentPersona = p;
        } else
          this.notificationService
            .showErrorWithTime('No se encuentra una persona seleccionada. Se redirigirá a la pantalla de búsqueda.', 5000)
            .afterDismissed().subscribe(() => {
              this.router.navigateByUrl(
                this.localStorageService.getIsVip
                  ? environment.URL_RETURN_APP_VIP
                  : this.localStorageService.getIsExternoRDS
                    ? environment.URL_RETURN_APP_RDS
                    : environment.URL_RETURN_APP
              );
            });
      }
    });
  }

  //METODO LEGACY -- NO UTILIZAR
  getMenuLegacy() {
    const country = this.regionSeleccionada.getCode()?.toUpperCase();
    const serviceCountry = this.regionSeleccionada.getService();

    // cambio para buscar el MENU_VIP
    let urlBaseApi: string;
    let rutaVip: string; //predefinida ruta anterior

    // console.log('this.localStorageService.getIsVip', this.localStorageService.getIsVip);

    // cambio para ruta de Microservicios
    const rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? this.localStorageService.configInit["F_URL_MS_IM_GCP"] + "/"
      : "";

    if (this.localStorageService.getIsVip) {
      urlBaseApi = this.localStorageService.configInit["F_VIP_URL_BASE_API"];
      rutaVip = "vip/gcp-service/v1";
    } else {
      urlBaseApi = this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
      rutaVip = "api/v1";
    }

    if (rutaMicroservicio && rutaVip == "api/v1") {
      rutaVip = rutaMicroservicio + "api/v1";
    }

    let tipoColeccion: string = "";
    if (this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS) {
      tipoColeccion = "_RDS"
    }

    // TODO: Agregar condicion para flujo publico desde variable persistida
    const isUrlVip = (this.localStorageService.getIsVip || this.localStorageService.getMenuApp?.title === OptionAbmMenu.FUENTES_VIP) ? '_VIP' : '';
    const isStringTkl = this.isStringTkl(serviceCountry);
    const urlConsume = environment.CONSUME_API_MENU.toString().toLowerCase() === "true"
      ? `${urlBaseApi}/${rutaVip}/menu/data/MENU_${country}${tipoColeccion}${isStringTkl}${isUrlVip}`
      : `assets/mock/${country.toLowerCase()}/MENU_${country}${tipoColeccion}${isStringTkl}${isUrlVip}.json`;
    return this.http.get<any>(urlConsume).pipe(
      retry({
        count: 3,
        delay: (error, retryCount) => {
          // Parsear el código del string que retorna el interceptor: "Código: 429, Mensaje: ..."
          const errorCode = typeof error === 'string' && error.includes('Código:')
            ? parseInt(error.split('Código:')[1].split(',')[0].trim())
            : (error?.status || -1);

          // Solo reintentar si es error 429 (Too Many Requests)
          if (errorCode === 429) {
            console.log(`Reintento ${retryCount} de 3 por error 429 en getMenu`);
            return of(null).pipe(timeout(2000)); // Esperar 2 segundos
          }
          // Para otros errores, lanzar error inmediatamente
          return throwError(() => error);
        }
      }),
      timeout(Number(environment.HTTP_REQUEST_TIMEOUT))
    );
  }

  isStringTkl(serviceCountry: string): string {
    return (serviceCountry.toUpperCase() === 'TKL') ?
      '_TKL' :
      '';
  }

  getEstructuraDinamica(domain: string, subDomain: string, config?: string) {
    // console.log('%c ' + this.serviceName + " , " + 'getEstructuraDinamica(domain: string, subDomain: string, config?: string)', 'background: green; color: white');
    // console.log("country : ", this.regionSeleccionada?.getCode()?.toUpperCase());
    // console.log('domain', domain);
    // console.log('subDomain', subDomain);
    // console.log('config', config);

    // Si no se proporciona config, intentar obtenerla del localStorage
    if (!config) {
      config = this.localStorageService.getSelectedGfdConfig;
      console.log('[FuenteDinamicaService.getEstructuraDinamica] Usando config desde localStorage:', config);
    }

    const domainUpper = (domain || '').toUpperCase();
    const isRdsDomain = domainUpper.startsWith('RDS_') || domainUpper === 'RDS';
    const hasRdsFlags = this.isRDS || this.localStorageService.getIsExternoRDS;
    const shouldUseRds = isRdsDomain || (!domainUpper && hasRdsFlags);

    // Log para depuración
    console.log('[FuenteDinamicaService.getEstructuraDinamica] domainUpper:', domainUpper);
    console.log('[FuenteDinamicaService.getEstructuraDinamica] isRdsDomain:', isRdsDomain);
    console.log('[FuenteDinamicaService.getEstructuraDinamica] hasRdsFlags:', hasRdsFlags);
    console.log('[FuenteDinamicaService.getEstructuraDinamica] shouldUseRds:', shouldUseRds);

    // Si es RDS por dominio/flags, usar RDS; de lo contrario usar GFD
    if (shouldUseRds) {
      console.log('[FuenteDinamicaService.getEstructuraDinamica] Usando RDS Service');
      // Para RDS, la collection es la combinación de domain_subDomain
      const collection = `${domain}_${subDomain}`;
      console.log('[FuenteDinamicaService.getEstructuraDinamica] Collection:', collection);
      return this.rdsService.getRdsGfd(collection, config);
    } else {
      console.log('[FuenteDinamicaService.getEstructuraDinamica] Usando GFD Service');
      // Si aún no hay config, el servicio GFD usará el default
      return this.gfdService.getGfd(domain, subDomain, config);
    }
  }

  isStringGkl(service: string): string {
    return (service.toUpperCase() === 'GKL') ?
      '_GKL' :
      '';
  }

  getDataFuenteDinamicaList(
    sourceJoFull: string,
    route: string,
    currentCountry: string,
    typeSearch: string,
    dominioSubDominioGKL: string,
    baseUrlfuente: string,
    periods: boolean,
    idHashDataAdded: string,
    periodsMatchKeyField?: string,
    isPreviewTwo: boolean = false
  ) {
    this.getCurrentPerson();

    this.paramSourceJoFull = sourceJoFull;
    this.paramRoute = route;
    this.paramCurrentCountry = currentCountry;
    this.paramServiceMenu = this.regionSeleccionada?.getService();
    this.paramTypeSearch = typeSearch;
    this.paramDominioSubDominioGKL = dominioSubDominioGKL;
    this.paramBaseUrlfuente = baseUrlfuente;
    this.dominioSubDominioDISGKL = dominioSubDominioGKL;

    const sourceEndpoint = this.sharedService.getEndpoint(sourceJoFull);

    if (!(this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS)) {
      if (!this.currentPersona) { return of([]); }
    }

    let idHashData: string;

    if (isPreviewTwo) {
      idHashData = idHashDataAdded;
    } else {
      if (this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS) {
        idHashData = idHashDataAdded;
      } else {
        if (!this.currentPersona) { return of([]); } // Se movió la validación aquí
        idHashData = this.getIdHash(currentCountry, this.regionSeleccionada?.getService(), typeSearch, route, idHashDataAdded);
      }
    }

    if (sourceEndpoint === "DELINQUENCY_BED_EXCH") {
      if (!idHashData) {
        idHashData = this.getIdHash(currentCountry, this.regionSeleccionada?.getService(), typeSearch, route, idHashDataAdded);
      }
      return this.enviaEndpointFinalBed(idHashData, currentCountry, baseUrlfuente, periods, sourceEndpoint);
    }

    baseUrlfuente = this.baseUrlInGFD(baseUrlfuente);

    // Evita errores por baseUrl nulo en runtime
    if (!baseUrlfuente) {
      baseUrlfuente = "/api/v4/sources/";
    }

    if (this.localStorageService.getIsExternoRDS) {
      baseUrlfuente = "/api/v1/pk/";
    }

    let finalUrl: string;
    let objParamsGklHash;

    if (environment.CONSUME_API_DATA.toString().toLowerCase() === "true") {
      if (baseUrlfuente.includes('/sources/periods/')) {
        // Para fuentes con períodos, distinguir entre búsqueda normal y avanzada
        // En búsqueda avanzada: idHashData contiene valores concatenados (ej: "hash1.affiliateId.accountHash")
        // En búsqueda normal: idHashData es un solo hash sin puntos intermedios
        // Detectamos búsqueda avanzada si hay puntos Y el valor después del primer punto no está vacío
        const sep = this.localStorageService.dataEstructuraDinamicaHeader?.separator || '.';
        const matchKeyParts = idHashData.split(sep);
        const hasMultipleFields = matchKeyParts.length > 1 && matchKeyParts[1]?.trim() !== '';
        const baseMatchKey = hasMultipleFields ? idHashData : matchKeyParts[0];

        if (!periodsMatchKeyField) {
          this.notificationService.showError("Error de configuración: 'periodsMatchKeyField' es requerido.");
          return of([]);
        }
        const params = new HttpParams().set('matchkey', baseMatchKey).set('periodName', periodsMatchKeyField);
        objParamsGklHash = { headers: this.getTokenToHeaders(), params: params };
      } else if (isPreviewTwo) {
        // Para /sources/history/ o cuando es preview 2, usa el idHashData tal cual (ya viene procesado/truncado)
        const params = new HttpParams().set('matchkey', idHashData);
        objParamsGklHash = { headers: this.getTokenToHeaders(), params: params };
      } else {
        // Comportamiento por defecto: no se agrega separador al final.
        // El backend no lo requiere para /api/v4/sources/ list calls.
        const params = new HttpParams().set('matchkey', idHashData);
        objParamsGklHash = { headers: this.getTokenToHeaders(), params: params };
      }

      let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true" && !this.localStorageService.getIsVip)
        ? "/" + this.localStorageService.configInit["F_URL_MS_IM_JOURNALING"]
        : "";

      if ((this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS) && !this.localStorageService.getIsVip) {
        rutaMicroservicio = "/" + this.localStorageService.configInit["F_URL_MS_IM_RDS"];
      }

      const urlBaseApi = (this.localStorageService.getIsVip)
        ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
        : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];

      finalUrl = `${urlBaseApi}${rutaMicroservicio}${baseUrlfuente}${currentCountry.toUpperCase()}/${this.dominioSubDominioDISGKL}`;

      if (this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS) {
        finalUrl = `${urlBaseApi}${rutaMicroservicio}${baseUrlfuente}${currentCountry.toUpperCase()}/${this.paramSourceJoFull}`;
      }

    } else {
      console.log(`CONSUME_API_DATA is false. Using local mock for ${sourceEndpoint}.`);
      finalUrl = `assets/mock/${currentCountry?.toLowerCase()}/preview/DATA_${sourceEndpoint}.json`;
      objParamsGklHash = {};
    }

    console.log("FINALURL: ", finalUrl)

    return this.callEndpointDataFuenteDinamicaList(finalUrl, objParamsGklHash, periods);
  }

  enviaEndpointFinalBed(recidHashData: string, reccurrentCountry: string,
    recbaseUrlfuente: string, recperiods: boolean, recsourceEndpoint: string) {
    let idHasDataBed = recidHashData;
    if (this.filtrosMatchKey != "") {
      idHasDataBed = recidHashData + '.' + this.filtrosMatchKey;
    }

    recbaseUrlfuente = this.baseUrlInGFD(recbaseUrlfuente);

    let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true" && !this.localStorageService.getIsVip)
      ? "/" + this.localStorageService.configInit["F_URL_MS_IM_JOURNALING"]
      : "";

    let urlBaseApi = (this.localStorageService.getIsVip)
      ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
    const urlGklHash = (environment.CONSUME_API_DATA.toString().toLowerCase() === "true") ?
      `${urlBaseApi}${rutaMicroservicio}${recbaseUrlfuente}${reccurrentCountry.toUpperCase()}/${this.dominioSubDominioDISGKL}` :
      `assets/mock/${reccurrentCountry?.toLowerCase()}/preview/DATA_${recsourceEndpoint}.json`;
    const internalIdHashGklHash = 'matchkey';

    this.localStorageService.setObservationListMatchkey = idHasDataBed;
    const paramGklHash = new HttpParams().set(internalIdHashGklHash, idHasDataBed + '.');
    const objParamsGklHash = {
      headers: this.getTokenToHeaders(),
      params: paramGklHash
    };

    let returnApiData = this.callEndpointDataFuenteDinamicaList(urlGklHash, objParamsGklHash, recperiods);
    return returnApiData;

  }

  // retorna el string baseURL para el caso de GFD
  baseUrlInGFD(baseUrlfuente: string, subDominio: string = '') {
    if (!baseUrlfuente) {
      return '';
    }

    if (this.localStorageService.getIsVip) {
      const urlMappings: Record<string, string> = {
        "/api/v3/sources/lastmk/": "/vip/journaling-service/v3/sources/lastmk/",
        "/api/v1/sources/periods/": "/vip/journaling-service/v1/sources/periods/",
        "/api/v1/sources/documents/": "/vip/journaling-service/v1/sources/documents/",
        "/api/v3/sources/details/filter/": "/vip/journaling-service/v3/sources/details/filter/",
        "/api/v4/sources/filter/": "/vip/journaling-service/v4/sources/filter/",
        "/api/v3/sources/details/": "/vip/journaling-service/v3/sources/details/",
        "/api/v2/sources/history/": "/vip/journaling-service/v2/sources/history/"
      };

      if (baseUrlfuente === "/api/v4/sources/") {
        return subDominio === 'CONTRIBUTOR_PAYMENT'
          ? "/vip/journaling-service/v4/sources/"
          : "/vip/journaling-service/v4/sources/matriz/";
      }

      return urlMappings[baseUrlfuente] || baseUrlfuente;
    }

    return baseUrlfuente
  }

  callEndpointDataFuenteDinamicaList(urlGklHash: string, objParamsGklHash: { headers: { Authorization: string; }; params: HttpParams; }, periods?: boolean) {
    // console.log('urlGklHash, objParamsGklHash');
    // console.log(urlGklHash, objParamsGklHash);
    let returnApiData = null;

    // Detectar si es un mock (archivo local)
    const isMockUrl = urlGklHash.includes('assets/mock');

    if (isMockUrl) {
      // Para mocks, siempre usar GET independientemente de si es VIP o RDS
      console.log('[FuenteDinamicaService] Usando mock local con GET:', urlGklHash);
      returnApiData = this.http.get<any>(urlGklHash).pipe(
        timeout(Number(environment.HTTP_REQUEST_TIMEOUT)),
        map(data => {
          // Procesar la respuesta del mock según el formato
          if (data && data.payload) {
            // Formato VIP/Normal
            const letSources = this.callEndpointDataFuenteDinamicaListMap(data);
            return periods ? data.payload : data.payload[letSources];
          } else if (data && data.response && Array.isArray(data.response)) {
            // Formato RDS
            if (data.response[0]?.values) {
              return [data.response[0].values];
            }
            return data.response;
          } else if (Array.isArray(data)) {
            // Array directo
            return data;
          }
          return data;
        }),
        catchError(err => {
          console.error('[FuenteDinamicaService] Error al cargar mock:', err);
          return of([]);
        })
      );
    } else if (this.localStorageService.getIsVip) {
      // Obtener matrizVipField del header
      const matrizVipField = this.localStorageService.dataEstructuraDinamicaHeader?.matrizVipField;

      let sMatrizVip: any = {
        'matriz': this.localStorageService.getMatrizArray
      };

      // Agregar el campo field si está configurado en el header
      if (matrizVipField) {
        sMatrizVip = {
          'field': matrizVipField,
          'matriz': this.localStorageService.getMatrizArray
        };
      }

      returnApiData = this.http.post<any>(
        urlGklHash, sMatrizVip, objParamsGklHash
      ).pipe(
        retry({
          count: 3,
          delay: (error, retryCount) => {
            const errorCode = typeof error === 'string' && error.includes('Código:')
              ? parseInt(error.split('Código:')[1].split(',')[0].trim())
              : (error?.status || -1);
            if ([502, 503, 504].includes(errorCode)) {
              console.log(`[VIP] Reintento ${retryCount} de 3 por error ${errorCode} en POST matriz`);
              return of(null).pipe(timeout(2000));
            }
            return throwError(() => error);
          }
        }),
        timeout(Number(environment.HTTP_REQUEST_TIMEOUT)),
        map(data => {
          const letSources = this.callEndpointDataFuenteDinamicaListMap(data);
          try {
            this.keyingGkl = data.payload[letSources][0].keying ? data.payload[letSources][0].keying : null; // TODO: revisar algo falla pero no afecta a posterior, si no sacar
            this.keyingGklBackup = data.payload[letSources][0].keying ? data.payload[letSources][0].keying : null;
            if (this.keyingGklBackup) {
              console.log('[KEYING] Keying cargado desde backend (POST) - keyingGklBackup actualizado');
            } else {
              console.log('[KEYING] No se encontro keying en respuesta POST - keyingGklBackup seteado a null');
            }
          } catch (error) {
          }
          const payload = periods ? data.payload : data.payload[letSources];
          return payload;
        }),
        catchError(err => {
          // Si hay error (404 - persona sin registros), resetear el keying backup
          // console.log('[KEYING] Error al cargar datos desde backend POST (404 - sin registros previos) - Reseteando keyingGklBackup a null');
          // this.keyingGkl = null;
          // this.keyingGklBackup = null;
          return of([]);
        })
      );
    } else if (this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS) {
      let sMatrizRds = {
        'keysRequested': [
          this.localStorageService.getPrimarykeyRds
        ]
      }
      returnApiData = this.http.post<any>(
        urlGklHash, sMatrizRds, objParamsGklHash
      ).pipe(
        timeout(Number(environment.HTTP_REQUEST_TIMEOUT)),
        map(data => {
          if (data?.response[0]?.statusCode === 404) {
            this.notificationService
              .showError(data?.response[0]?.statusMessage)
            return null;
          } else {
            const payload = [data?.response[0]?.values];
            return payload;
          }
        }),
        catchError(err => {
          return of([]);
        })
      );
    } else {
      returnApiData = this.http.get<any>(
        urlGklHash, objParamsGklHash
      ).pipe(
        timeout(Number(environment.HTTP_REQUEST_TIMEOUT)),
        map(data => {
          console.log('[getDataFuenteDinamicaList] GET response data:', data);
          const letSources = this.callEndpointDataFuenteDinamicaListMap(data);
          console.log('[getDataFuenteDinamicaList] letSources después de map:', letSources);
          try {
            this.keyingGkl = data.payload[letSources][0].keying ? data.payload[letSources][0].keying : null; // TODO: revisar algo falla pero no afecta a posterior, si no sacar
            this.keyingGklBackup = data.payload[letSources][0].keying ? data.payload[letSources][0].keying : null;
            if (this.keyingGklBackup) {
              console.log('[KEYING] Keying cargado desde backend (GET) - keyingGklBackup actualizado');
            } else {
              console.log('[KEYING] No se encontro keying en respuesta GET - keyingGklBackup seteado a null');
            }
          } catch (error) {
          }
          const payload = periods ? data.payload : data.payload[letSources];
          console.log('[getDataFuenteDinamicaList] payload final que se retornará:', payload);
          console.log('[getDataFuenteDinamicaList] payload es array?:', Array.isArray(payload), 'length:', payload?.length);
          return payload;
        }),
        catchError(err => {
          // Si hay error (404 - persona sin registros), resetear el keying backup
          // console.log('[KEYING] Error al cargar datos desde backend GET (404 - sin registros previos) - Reseteando keyingGklBackup a null');
          // this.keyingGkl = null;
          // this.keyingGklBackup = null;
          return of([]);
        })
      );
    }

    return returnApiData;
  }

  callEndpointDataFuenteDinamicaListMap(data: any) {
    console.log('[callEndpointDataFuenteDinamicaListMap] data recibida:', data);
    console.log('[callEndpointDataFuenteDinamicaListMap] data.payload:', data?.payload);
    if (this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS) {
      return null;
    } else {
      // Extraer las claves del payload
      const payloadKeys = data?.payload ? Object.keys(data.payload) : [];
      console.log('[callEndpointDataFuenteDinamicaListMap] Claves disponibles en payload:', payloadKeys);

      let letSources = payloadKeys[0];
      console.log('[callEndpointDataFuenteDinamicaListMap] letSources extraído (primera clave):', letSources);

      // Verificar si hay datos en esta clave
      const dataArray = data.payload[letSources];
      console.log('[callEndpointDataFuenteDinamicaListMap] data.payload[letSources]:', {
        isArray: Array.isArray(dataArray),
        length: dataArray?.length,
        data: dataArray
      });

      this.filteredData = [];
      // solucion para PRD registros duplicados
      if (letSources === "BUSINESS_PARTNER") { // TODO: hacer esto dinámico en STRUCT o MENU
        const groupedData = {};
        data.payload[letSources].forEach(item => {
          const key = `${item.company_rut}-${item.partner_rut}`;
          if (!groupedData[key] || item.journalingTimestamp > groupedData[key].journalingTimestamp) {
            groupedData[key] = item;
          }
        });
        this.filteredData = Object.values(groupedData);
        data.payload[letSources] = this.filteredData;
      }
      return letSources;
    }
  }

  getIdHash(currentCountry: string, serviceCountry: string, typeSearch: string, route: string, idHashDataAdded: string) {
    // Bypass: si el modal de busqueda avanzada dejo una matchkey completa, usarla
    // tal cual sin preponer el hash de la persona. Se consume una vez.
    const fullAdvanced = this.localStorageService.getFullMatchKeyAdvanced;
    if (fullAdvanced) {
      this.localStorageService.setFullMatchKeyAdvanced = '';
      this.localStorageService.setPersonaSelectedDniHash = fullAdvanced;
      return fullAdvanced;
    }

    const personaSelected: any = this.localStorageService.getPersonaSelected || {};
    const buscadorSelect = this.localStorageService.getBuscadorSelect;

    let typeDni: string | null = null;
    let typeSearchFull: string | null = null;
    if (typeSearch !== null) {
      typeSearchFull = typeSearch; // cuando la variable viene del MENU_XX
    } else if (serviceCountry === 'tkl') {
      typeDni = 'iup';
      typeSearchFull = 'iup';  // cuando es tkl
    } else {
      typeDni = 'cedula'; // cuando es gkl o hash
      typeSearchFull = buscadorSelect?.isHash ? 'hash' : 'entityKey'; // cuando es gkl o hash
    }
    // console.log('typeDni', typeDni);
    // console.log('typeSearchFull', typeSearchFull);
    let idDni = typeDni ? personaSelected[typeDni] : this.localStorageService.getPersonaSelectedDni;
    let idHashData = typeSearchFull ? personaSelected[typeSearchFull] : undefined;

    if (!idHashData) {
      idHashData = this.localStorageService.getPersonaSelectedDniHash || personaSelected['entityKey'] || '';
    }

    // console.log('idHashDataAdded', idHashDataAdded);
    idHashData = (idHashDataAdded === '') ? idHashData : String(idHashData || '') + idHashDataAdded;
    this.localStorageService.setPersonaSelectedDni = idDni;
    this.localStorageService.setPersonaSelectedDniHash = idHashData;
    // console.log('idHashData5', idHashData);

    // console.log('idHashData', idHashData);
    return idHashData;
  }

  createObjectDISArray(value: Array<any>, fieldValues: Array<any>) {
    console.log("createObjectDISArray value ------>", value);
    console.log("createObjectDISArray fieldValues ------->", fieldValues);
    if (!value) {
      return null;
    }

    const valuesSalida: any[] = [];

    value.forEach(itemValue => {

      const newItem = {};

      fieldValues.forEach(itemStruct => {
        const key = itemStruct.name;
        const currentValue = itemValue[key];

        if (Boolean(itemStruct.nullable)) {
          const nestedObject = {};
          nestedObject[itemStruct.type] = currentValue;
          newItem[key] = nestedObject;
        } else {

          newItem[key] = currentValue;
        }
      });

      valuesSalida.push(newItem);
    });

    return valuesSalida;
  }

  //A ESTE METODO SOLO SE DEBERIA ENTRAR AL MOMENTO DE CREAR UNA ENTIDAD PERSONA/EMPRESA (NO UTILIZAR PARA CREAR KEYING EN OTRAS FUENTES)
  async consumeKeyingAddEntity(changeData: any) {
    let profileKeying: any = "";
    profileKeying = "";
    profileKeying = JSON.parse(JSON.stringify([]));
    const buscadorSelect = this.localStorageService.getBuscadorSelect;
    const identifyType = buscadorSelect?.identifyType;
    const typeNumber = buscadorSelect?.typeNumber;
    const profile = buscadorSelect?.profile;

    if (!identifyType || !profile) {
      console.warn('[KEYING] Falta configuración de buscador para crear keying. Se omite keying de alta entidad.');
      this.keyingGkl = [];
      this.keyingGklBackup = [];
      changeData['keying'] = [];
      return changeData['keying'];
    }

    const subDomain = this.localStorageService.dataEstructuraDinamicaHeader.subDomainJO;
    // console.log("consumeKeyingAddEntity identifyType ---->", identifyType)
    // console.log('consumeKeyingAddEntity changeData', changeData);

    // console.log('consumeKeyingAddEntity this.localStorageService.getBuscadorSelect ---->', this.localStorageService.getBuscadorSelect);

    // Países que no requieren keying: aquellos con service 'hash' en COUNTRIES.json
    const includesCountryEmpty = (COUNTRIES as any[])
      .filter(c => c.service === 'hash')
      .map(c => (c.code as string).toUpperCase())
    const countryCode = this.regionSeleccionada.getCode().toUpperCase();
    const countryName = this.regionSeleccionada.getName().toUpperCase();

    if (includesCountryEmpty.includes(countryCode)) {
      console.log(`[KEYING] Pais ${countryCode} no requiere keying - Reseteando keyingGkl y keyingGklBackup a array vacio`);
      this.keyingGkl = [];
      this.keyingGklBackup = [];
      changeData['keying'] = [];
      return changeData["keying"];
    } else {

      // Obtener profiles del header de la fuente
      const headerProfiles = this.localStorageService.dataEstructuraDinamicaHeader?.profiles;

      // Prioridad 1: header | Prioridad 2: servicio GET de región
      const regionProfiles = await this.getRegionProfiles(countryCode);

      const profiledeIngestaConsumer = headerProfiles?.ingestaConsumer || regionProfiles?.ingestaConsumer || "";
      const profiledeIngestaCommercial = headerProfiles?.ingestaCommercial || regionProfiles?.ingestaCommercial || "";

      const profileId = profile === 'COMMERCIAL' ? profiledeIngestaCommercial : profiledeIngestaConsumer || "";


      //Si la denominacion viene en el changeData la usamos, en caso contrario obtenemos del dataFuenteBackup
      let denominacion = "";
      if (changeData.apellidos && changeData.nombres) {
        denominacion = changeData.apellidos + "," + changeData.nombres;
      } else {
        // Si no viene en changeData, obtener del backup de localStorage
        denominacion = this.localStorageService.dataFuenteBackup?.denominacion || "";
      }

      // Obtener documento: primero de changeData, luego de personaSelected, y finalmente del backup
      let documento = changeData.documento_numero || this.localStorageService.getPersonaSelectedDni;
      if (!documento) {
        documento = this.localStorageService.dataFuenteBackup?.documento;
      }
      if (!documento) {
        // Como último recurso, obtener del valor guardado al crear la entidad
        documento = this.localStorageService.getAltaEntidadDocumento || "";
      }

      let tipoDocumento = "";

      if (countryCode === 'AR') {
        // Primero intentar obtener el tipo de documento de changeData
        if (changeData.documento_tipo) {
          tipoDocumento = changeData.documento_tipo;
        } else {
          // Si no viene en changeData, determinar por identifyType
          if (identifyType === '16') {
            tipoDocumento = 'CUIL';
          } else if (identifyType === '1') {
            tipoDocumento = 'DNI';
          } else {
            console.warn("[KEYING] Tipo de documento no especificado para AR, falta obtener de otra forma");
          }
        }
      }

      if (countryCode === 'AR' && profile === 'COMMERCIAL') {
        profileKeying = JSON.parse(JSON.stringify(keying_ar_commercial(documento, denominacion)));
      } else if (countryCode === 'PY' && subDomain === 'NATURAL_PERSON') {
        const dataKeying = changeData;
        dataKeying.identifyType = identifyType;
        profileKeying = JSON.parse(JSON.stringify(keying_py_consummer(dataKeying)));
      } else if (countryCode === 'PY' && profile === 'COMMERCIAL') {
        profileKeying = JSON.parse(JSON.stringify(keying_py_comercial(changeData.razon_social, changeData.documento)));
      } else {
        // Adjuntar names del buscador (NAME_FULL, NAME_FIRST_NAME, etc.) para enriquecer el keying en ingestas
        const searcherNames = this.localStorageService.getKeyingNamesData;
        if (searcherNames && !changeData['_searcherNames']) {
          changeData['_searcherNames'] = searcherNames;
        }
        profileKeying = JSON.parse(JSON.stringify(keyingAll(denominacion, documento, tipoDocumento, typeNumber, countryCode, countryName, profile, profileId, identifyType, changeData)));
        delete changeData['_searcherNames'];
      }

      console.log(`[KEYING] Generando nuevo keying usando keyingAll - Pais: ${countryCode}, Profile: ${profile}, Documento: ${documento}`);

      // console.log("consumeKeyingAddEntity profileKeying ------>", profileKeying);

      this.keyingGkl = "";
      this.keyingGkl = profileKeying;

      // console.log("consumeKeyingAddEntity this.keyingGkl ---->", this.keyingGkl);

      const parametroKeying = this.localStorageService.configInit["F_PARAMETRO_KEYING"];//environment.PARAMETRO_KEYING;
      let result = this.keyingGkl;

      let type = "";
      try {
        if (this.keyingGkl[0].request.session.entityType) {
          type = this.keyingGkl[0].request.session.entityType;
        } else {
          type = this.keyingGkl[0].request.entity.consumer !== null ? "CONSUMER" : 'COMMERCIAL';
        }
      } catch (error) {
        alert('ERROR DESARROLLO: Consumo del servicio no viene con valor keyingGkl o entityType, por favor reportar');
      }

      const sessionObj = this.keyingGkl[0].request.session;
      const sessionString = `{"${parametroKeying}Session":${JSON.stringify(sessionObj)}}`;

      result[0].request.session = JSON.parse(sessionString);
      const resplaces = result;

      let keying = "";
      let key = resplaces;

      if (type === "CONSUMER") {
        const consumer = this.keyingGkl[0].request.entity.consumer;
        const cons = `{"${parametroKeying}Consumer":${JSON.stringify(consumer)}}`;
        key[0].request.entity.consumer = JSON.parse(cons);
        keying = key;
      } else {
        const commercial = this.keyingGkl[0].request.entity.commercial;
        const cons = `{"${parametroKeying}Commercial":${JSON.stringify(commercial)}}`;
        key[0].request.entity.commercial = JSON.parse(cons);
        keying = key;
      }

      changeData['keying'] = keying;

      // Actualizar el backup con el keying recién generado para esta persona
      this.keyingGklBackup = JSON.parse(JSON.stringify(keying));
      console.log(`[KEYING] Backup actualizado con el keying recien generado - Profile: ${profile}`);

      return changeData["keying"];
    }

  }

  // method create keying atribute for DIS OBJECT
  async consumeKeying(valuesChange: {}, atributosFuenteModif: string[], subDomainJO: string, currentCountryUpper: string, serviceMenu: string, isAdding: boolean = false) {
    // console.log('%c ' + this.serviceName + " / " + 'consumeKeying(changeData: {}, tipoServicioGkl: boolean)', 'background: GREEN; color: white');
    // console.log("valuesChange : ", valuesChange);
    // console.log("subDomainJO : ", subDomainJO);
    // console.log("currentCountryUpper : ", currentCountryUpper);
    // console.log("serviceMenu : ", serviceMenu);
    // console.log("isAdding : ", isAdding);

    // Si estamos editando (no isAdding), pais GKL, y keying original era null o [], respetarlo
    const serviceUpper = (serviceMenu || this.regionSeleccionada?.getService() || '').toUpperCase();
    if (!isAdding && serviceUpper === 'GKL') {
      if (this.keyingGklBackup === null) {
        console.log('[KEYING] Editando en pais GKL con keying original null - Manteniendo keying como null');
        valuesChange['keying'] = null;
        return valuesChange['keying'];
      }
      if (Array.isArray(this.keyingGklBackup) && this.keyingGklBackup.length === 0) {
        console.log('[KEYING] Editando en pais GKL con keying original vacio - Manteniendo keying como []');
        valuesChange['keying'] = [];
        return valuesChange['keying'];
      }
    }

    // Validar si keyingGklBackup es null o vacío, si es así, generar uno nuevo usando keyingAll
    if (this.keyingGklBackup === null || this.keyingGklBackup === undefined ||
      (Array.isArray(this.keyingGklBackup) && this.keyingGklBackup.length === 0)) {
      // Si no hay keying backup válido, generar uno nuevo con consumeKeyingAddEntity
      console.log('[KEYING] No existe keying backup valido - Generando nuevo keying usando consumeKeyingAddEntity');
      valuesChange['keying'] = await this.consumeKeyingAddEntity(valuesChange);
      return valuesChange['keying'];
    }

    console.log('[KEYING] Usando keying de operacion anterior (keyingGklBackup) - Aplicando modificaciones de perfil');
    this.keyingGkl = JSON.parse(JSON.stringify(this.keyingGklBackup));
    let profileConsumer: string = "";
    let profileCommercial: string = "";

    // Obtener profiles del header de la fuente
    const headerProfiles = this.localStorageService.dataEstructuraDinamicaHeader?.profiles;

    // Prioridad 1: header | Prioridad 2: servicio GET de región
    const regionProfiles = await this.getRegionProfiles(currentCountryUpper);

    // Si es una creación nueva (isAdding), usar perfiles de INGESTA
    // Si es una edición (isAdding=false), usar perfiles de EDICIÓN
    if (isAdding) {
      console.log('[KEYING] Operación de INGESTA - Usando perfiles de ingesta');
      profileConsumer = headerProfiles?.ingestaConsumer || regionProfiles?.ingestaConsumer || "";
      profileCommercial = headerProfiles?.ingestaCommercial || regionProfiles?.ingestaCommercial || "";
    } else {
      console.log('[KEYING] Operación de EDICIÓN - Usando perfiles de edición');
      profileConsumer = headerProfiles?.editionConsumer || regionProfiles?.editionConsumer || "";
      profileCommercial = headerProfiles?.editionCommercial || regionProfiles?.editionCommercial || "";
    }

    if (this.regionSeleccionada?.getService()?.toUpperCase() !== 'HASH' && this.keyingGkl !== null && this.keyingGkl.length > 0) { // TODO: hacer esto dinámico en STRUCT o MENU
      let type = "";
      try {
        if (this.keyingGkl[0].request.session.entityType) {
          type = this.keyingGkl[0].request.session.entityType;
        } else {
          type = this.keyingGkl[0].request.entity.consumer !== null ? "CONSUMER" : 'COMMERCIAL';
        }
      } catch (error) {
        alert('ERROR DESARROLLO: Consumo del servicio no viene con valor keyingGkl o entityType, por favor reportar');
      }

      const sessionObj = this.keyingGkl[0].request.session;
      if (this.keyingGkl[0].request.session.entityType == undefined) {
        sessionObj.entityType = type;
      }

      // Aplicar el profile correcto según el tipo de entidad (CONSUMER o COMMERCIAL)
      if (type === "CONSUMER") {
        if (profileConsumer === null || profileConsumer === "") {
          profileConsumer = sessionObj.profileId
        }
        sessionObj.profileId = profileConsumer;
      } else {
        if (profileCommercial === null || profileCommercial === "") {
          profileCommercial = sessionObj.profileId
        }
        sessionObj.profileId = profileCommercial;
      }

      const parametroKeying = this.localStorageService.configInit["F_PARAMETRO_KEYING"]

      const sessionObjString = `{"${parametroKeying}Session":${JSON.stringify(sessionObj)}}`;

      this.keyingGkl[0].request.session = JSON.parse(sessionObjString);

      if (type === "CONSUMER") {
        const consumer = this.keyingGkl[0].request.entity.consumer;
        if (subDomainJO === 'NATURAL_PERSON' && currentCountryUpper == 'AR') {
          if (atributosFuenteModif.includes('sexo')) {
            let valueSex = 0;
            switch (valuesChange['sexo']) {
              case 'M':
                valueSex = 1;
                break;
              case 'F':
                valueSex = 2;
                break;
              case 'I':
              case 'X':
                valueSex = 3;
                break;
            }
            consumer.gender = valueSex;
          }
          if (atributosFuenteModif.includes('nombres')) {
            consumer.names[0].data.NAME_FULL = valuesChange['nombres'];
          }
        }
        const consumerString = `{"${parametroKeying}Consumer":${JSON.stringify(consumer)}}`;
        this.keyingGkl[0].request.entity.consumer = JSON.parse(consumerString);
      } else {
        const commercial = this.keyingGkl[0].request.entity.commercial;
        if (subDomainJO == 'LEGAL_ENTITY' && currentCountryUpper == 'AR') {
          if (atributosFuenteModif.includes('denominacion')) {
            commercial.names[0].data.NAME_BUSINESS_NAME = valuesChange['denominacion'];
          }
        }
        const commercialString = `{"${parametroKeying}Commercial":${JSON.stringify(commercial)}}`;
        this.keyingGkl[0].request.entity.commercial = JSON.parse(commercialString);
      }
      valuesChange['keying'] = this.keyingGkl;
    } else if (this.regionSeleccionada?.getService()?.toUpperCase() === 'HASH') {
      valuesChange['keying'] = [];
    } else {
      valuesChange['keying'] = [];
    }

    return valuesChange["keying"];
  }
  // FIN DIS ------------------------

  /**
   * Elimina uno o varios registros de una fuente dinámica mediante soft delete.
   *
   * MEJORA DISPONIBLE - USO ROBUSTO CON matchKeyFields:
   * Para evitar problemas con valores que contienen puntos (ej: emails como "user@gmail.com"),
   * se recomienda obtener los fields del matchKey ANTES de llamar a este método y guardarlos
   * en una variable de clase del componente.
   *
   * Ejemplo de uso óptimo en el componente:
   * ```typescript
   * // 1. En ngOnInit o al cargar los datos, obtener y cachear los fields:
   * this.fuenteDinamicaService.getMatchKey(country, domain, subdomain).subscribe({
   *   next: (response: any) => {
   *     this.matchKeyFields = response?.fields || []; // Guardar en variable de clase
   *     this.matchKeySeparator = response?.separator || '.'; // Si el API lo retorna
   *   }
   * });
   *
   * // 2. Al eliminar, pasar los fields cacheados:
   * this.fuenteDinamicaService.deleteFuenteDinamicaSource(
   *   dominioSubDominioGKL,
   *   listToDelete,
   *   country,
   *   this.matchKeyFields,  // <-- Array de fields cacheados
   *   this.matchKeySeparator // <-- Separador (opcional)
   * ).subscribe(...);
   * ```
   *
   * @param dominioSubDominioGKL - Dominio/Subdominio en formato "DOMAIN/SUBDOMAIN"
   * @param listToDelete - Array de objetos a eliminar (deben tener propiedad matchKey)
   * @param countryDelete - Código del país
   * @param matchKeyFields - Opcional: Array de nombres de campos del matchKey (para robustez)
   * @param separator - Opcional: Separador del matchKey (por defecto '.')
   * @returns Observable con la respuesta del servicio de eliminación
   */
  deleteFuenteDinamicaSource(
    dominioSubDominioGKL: string,
    listToDelete: Array<any>,
    countryDelete: string,
    matchKeyFields?: string[],
    separator: string = '.'
  ) {
    const objParams = {
      headers: this.getTokenToHeaders()
    };

    let params = JSON.parse(JSON.stringify(objParams));
    let matchKeyFilter = "";

    if (listToDelete.length === 1) {
      matchKeyFilter = `isEqual('ingestionHeader.matchKey','${listToDelete[0].matchKey}')`;
    } else {
      const filterParts = listToDelete.map(el => `isEqual('ingestionHeader.matchKey','${el.matchKey}')`);
      matchKeyFilter = filterParts.join('.or(') + ')'.repeat(listToDelete.length - 1);
    }

    const usuarioSoftDelete = this.localStorageService.dataLogin?.getUser?.() || 'Externo';
    const [domain, subdomain] = dominioSubDominioGKL.split('/');
    const document = this.persistenciaService.getvalidaDocumentoPersona(countryDelete);

    // Obtener los segmentos comunes del matchKey para criteriaOptions
    // Si se proporcionan matchKeyFields, se usa el método robusto que NO falla con puntos en datos
    const commonMatchKey = this.getCommonMatchKeySegmentsFromObjects(
      listToDelete,
      countryDelete.toUpperCase(),
      domain,
      subdomain,
      separator,
      matchKeyFields  // Si es undefined, usa método legacy con split
    );

    const userComment = this.localStorageService.comment || `${listToDelete.length} registro(s) eliminados.`;
    this.localStorageService.comment = '';

    const dataToDelete = {
      criterios: matchKeyFilter,
      internalOp: "SOFT_DELETE",
      deletionReason: userComment,
      criteriaOptions: {
        rowKeyInfo: "PARTIAL",
        rowKeyFilter: commonMatchKey
      },
      audit: {
        origen: this.localStorageService.getIsVip ? "VIP" : "DM",
        comentarios: `Motivo de la eliminación: ${userComment}`,
        matchkeys: listToDelete.map(el => el.matchKey),
        user: usuarioSoftDelete,
        documento: document,
        domain: domain,
        subdomain: subdomain,
        operation: 'SOFT_DELETE'
      }
    };

    let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true")
      ? this.localStorageService.configInit["F_URL_MS_IM_DMS"] + '/'
      : "";

    let urlBaseApi = (this.localStorageService.getIsVip)
      ? `${this.localStorageService.configInit["F_VIP_URL_BASE_API"]}/vip`
      : `${this.localStorageService.configInit["F_PINGID_URL_BASE_API"]}/${rutaMicroservicio}api`;

    const url = `${urlBaseApi}/v1/dms/delete/criteria/${countryDelete.toUpperCase()}/${dominioSubDominioGKL}/${usuarioSoftDelete}`;

    return this.http.post<any>(url, dataToDelete, params)
      .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
  }

  // DEPRECATED - usar deleteFuenteDinamicaSource con matchKeyFields
  deleteFuenteDinamicaAnterior(dominioSubDominioGKL: string, listToDelete: string, Countrydelete) {
    const objParams = {
      headers: this.getTokenToHeaders()
    };

    let params = JSON.parse(JSON.stringify(objParams));
    let matchKey = "";
    const dataToDelete = {
      observations: {},
      internalOp: "SOFT_DELETE",
    };

    matchKey = "isEqual('ingestionHeader.matchKey'," + "'" + listToDelete + "')";
    dataToDelete.observations = ({ matchKey });

    let usuarioSoftDelete = this.localStorageService.dataLogin?.getUser?.() || 'Externo';

    // cambio para ruta de Microservicios
    let rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true" && !this.localStorageService.getIsVip)
      ? "/" + this.localStorageService.configInit["F_URL_MS_IM_DMS"]
      : "";

    let urlBaseApi = (this.localStorageService.getIsVip)
      ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
    return this.http.post<any>(`${urlBaseApi}${rutaMicroservicio}/api/v1/dms/${Countrydelete.toUpperCase()}/${dominioSubDominioGKL}/${usuarioSoftDelete}`, dataToDelete, params)
      .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
  }

  addFuenteDinamica(dataToSave) {
    return of(dataToSave);
  }

  getMatchKey(region: string, domain: string, subdomain: string) {
    let url: string;

    if (environment.CONSUME_API_DATA.toString().toLowerCase() === "true") {
      const rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true" && !this.localStorageService.getIsVip)
        ? "/" + this.localStorageService.configInit["F_URL_MS_IM_DIS"]
        : "";
      const urlBaseApi = (this.localStorageService.getIsVip)
        ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
        : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];

      url = `${urlBaseApi}${rutaMicroservicio}/api/v1/matchkey/${region.toUpperCase()}/${domain}/${subdomain}`;

      return this.http.get<string[]>(url, {
        headers: this.getTokenToHeaders(),
        observe: 'body'
      }).pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
    } else {
      // console.log(`CONSUME_API_DATA is false. Using local mock for matchkey ${region}/${domain}/${subdomain}.`);
      url = `assets/mock/${region.toLowerCase()}/matchkey/${domain}.${subdomain}.json`;

      return this.http.get<string[]>(url)
        .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
    }
  }

  addRDS(region: string, collection: string, dataToSaveDIS) {
    const rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true" && !this.localStorageService.getIsVip)
      ? "/" + this.localStorageService.configInit["F_URL_MS_IM_RDS"]
      : "";
    const urlBaseApi = (this.localStorageService.getIsVip)
      ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];

    const url = `${urlBaseApi}${rutaMicroservicio}/api/v1/pk/${region.toUpperCase()}/${collection}/record`;

    const objParams = {
      headers: this.getTokenToHeaders()
    };

    return this.http.post<any>(url, dataToSaveDIS, objParams).
      pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)))
  }

  async generateKeyingForUpdate(recordData: any): Promise<any> {
    // if (this.regionSeleccionada?.getService()?.toUpperCase() !== 'HASH' && this.keyingGkl !== null && this.keyingGkl.length > 0) {
    if (this.regionSeleccionada?.getService()?.toUpperCase() === 'HASH' || !recordData.keying || recordData.keying.length === 0) {
      console.log("El registro no tiene un 'keying' original para modificar.", recordData);
      return [];
    }

    const newKeying = JSON.parse(JSON.stringify(recordData.keying));
    const firstKeying = Array.isArray(newKeying) ? newKeying[0] : null;
    const request = firstKeying?.request;

    if (!request || typeof request !== 'object') {
      console.warn('[FuenteDinamicaService] generateKeyingForUpdate: keying sin request válido. Se omite keying en edición masiva.');
      return [];
    }

    const parametroKeying = this.localStorageService.configInit["F_PARAMETRO_KEYING"];
    const sessionKey = parametroKeying ? `${parametroKeying}Session` : null;
    const consumerKey = parametroKeying ? `${parametroKeying}Consumer` : null;
    const commercialKey = parametroKeying ? `${parametroKeying}Commercial` : null;

    const sessionObj = sessionKey && request.session?.[sessionKey]
      ? request.session[sessionKey]
      : request.session;

    if (!sessionObj || typeof sessionObj !== 'object') {
      console.warn('[FuenteDinamicaService] generateKeyingForUpdate: keying sin session válida. Se omite keying en edición masiva.');
      return [];
    }

    request.entity = request.entity || {};

    const consumerObj = consumerKey && request.entity.consumer?.[consumerKey]
      ? request.entity.consumer[consumerKey]
      : request.entity.consumer;

    const commercialObj = commercialKey && request.entity.commercial?.[commercialKey]
      ? request.entity.commercial[commercialKey]
      : request.entity.commercial;

    const countryCode = this.regionSeleccionada.getCode().toUpperCase();
    const menu = (this.localStorageService.getDataSourceSelected || {}) as Menu;
    const subDomain = menu.subDomainJO;

    const profileType = sessionObj.entityType
      || (consumerObj ? 'CONSUMER' : commercialObj ? 'COMMERCIAL' : 'CONSUMER');

    // Obtener profiles del header de la fuente
    const headerProfiles = this.localStorageService.dataEstructuraDinamicaHeader?.profiles;

    // Prioridad 1: header | Prioridad 2: servicio GET de región
    const regionProfiles = await this.getRegionProfiles(countryCode);

    // Obtener profileEdition según el tipo (COMMERCIAL vs CONSUMER)
    const profileId = profileType === 'COMMERCIAL'
      ? (headerProfiles?.editionCommercial || regionProfiles?.editionCommercial || sessionObj.profileId || '')
      : (headerProfiles?.editionConsumer || regionProfiles?.editionConsumer || sessionObj.profileId || '');

    sessionObj.profileId = profileId;

    if (countryCode === 'AR') {
      if (subDomain === 'NATURAL_PERSON' && profileType === 'CONSUMER') {
        if (recordData.hasOwnProperty('nombres') && consumerObj?.names?.[0]?.data) {
          consumerObj.names[0].data.NAME_FULL = recordData['nombres'];
        }
      } else if (subDomain === 'LEGAL_ENTITY' && profileType === 'COMMERCIAL') {
        if (recordData.hasOwnProperty('denominacion') && commercialObj?.names?.[0]?.data) {
          commercialObj.names[0].data.NAME_BUSINESS_NAME = recordData['denominacion'];
        }
      }
    }

    if (parametroKeying) {
      // Envolver 'session'
      request.session = JSON.parse(`{"${parametroKeying}Session":${JSON.stringify(sessionObj)}}`);

      // Envolver 'consumer' o 'commercial'
      if (profileType === "CONSUMER" && consumerObj) {
        request.entity.consumer = JSON.parse(`{"${parametroKeying}Consumer":${JSON.stringify(consumerObj)}}`);
      } else if (profileType === 'COMMERCIAL' && commercialObj) {
        request.entity.commercial = JSON.parse(`{"${parametroKeying}Commercial":${JSON.stringify(commercialObj)}}`);
      }
    } else {
      request.session = sessionObj;
      if (profileType === 'CONSUMER' && consumerObj) {
        request.entity.consumer = consumerObj;
      } else if (profileType === 'COMMERCIAL' && commercialObj) {
        request.entity.commercial = commercialObj;
      }
      console.error("ERROR: 'F_PARAMETRO_KEYING' no encontrado en la configuración. El 'keying' no será envuelto.");
    }

    return newKeying;
  }

  async massiveUpdateDis(payload: { selectedItems: any[], fieldsToUpdate: any, audit: any, header?: any }): Promise<Observable<any>> {
    const currentCountry = this.localStorageService.getRegionSeleccionada.getCode();

    // Obtener contexto defensivamente: preferir getDataSourceSelected, sino usar payload.header
    const dataSourceSelected = this.localStorageService.getDataSourceSelected;
    const currentSubDomain = dataSourceSelected?.subDomainJO || payload.header?.subDomainJO;
    const currentDomain =
      dataSourceSelected?.domainJO ||
      dataSourceSelected?.domaine ||
      payload.header?.domainJO ||
      payload.header?.domaine ||
      payload.header?.domain;

    // Si falta contexto en localStorage (flujo Sources externo), rehidratarlo para modifyFuenteDinamica.
    if (currentDomain && currentSubDomain && (!dataSourceSelected?.domainJO || !dataSourceSelected?.subDomainJO)) {
      const menuData = new Menu();
      menuData.domainJO = String(currentDomain).toUpperCase();
      menuData.domaine = String(currentDomain).toUpperCase();
      menuData.subDomainJO = String(currentSubDomain).toUpperCase();
      this.localStorageService.setDataSourceSelected = menuData;
    }

    if (!currentSubDomain) {
      console.error('[FuenteDinamicaService] massiveUpdateDis: No se pudo obtener subDomainJO ni de getDataSourceSelected ni del payload.header');
      throw new Error('No se pudo determinar el dominio secundario para la actualización masiva');
    }

    if (!currentDomain) {
      console.error('[FuenteDinamicaService] massiveUpdateDis: No se pudo obtener domainJO/domaine ni de getDataSourceSelected ni del payload.header');
      throw new Error('No se pudo determinar el dominio para la actualización masiva');
    }

    // Usar la estructura (struct) desde localStorage en vez del avroSchema
    const struct: any[] = this.localStorageService.getEstructuraDinamicaField || [];

    // Obtener los nombres de los campos modificados
    const modifiedFieldNames = Object.keys(payload.fieldsToUpdate);

    const dataArray = await Promise.all(payload.selectedItems.map(async item => {
      // Combinar el estado actual del item con los campos a actualizar
      const finalRecordState = { ...item, ...payload.fieldsToUpdate };

      // Limpiar campos auxiliares
      delete finalRecordState.normalizado_select;

      const disObject: any = {};

      // 1. keying — usar generateKeyingForUpdate que opera sobre el keying individual
      // de cada registro (deep clone), sin depender del singleton keyingGklBackup
      // que causa wrapping acumulativo cuando se procesan múltiples registros.
      const keying = await this.generateKeyingForUpdate(finalRecordState);
      disObject['keying'] = keying;

      // 2. Campos de datos desde struct
      for (const field of struct) {
        const fieldName = field.name;
        if (fieldName === 'matchKey' || fieldName === 'keying') continue;

        let valueCapture = finalRecordState[fieldName];

        // Caso especial: denominación en NATURAL_PERSON AR
        if (fieldName === 'denominacion' &&
          currentSubDomain === 'NATURAL_PERSON' &&
          currentCountry.toUpperCase() === 'AR') {
          valueCapture = finalRecordState.apellidos + ',' + finalRecordState.nombres;
        }

        // Construir tipo Avro según el campo
        let avroType: any;
        if (field.type === 'array' && field.subFields?.length > 0) {
          avroType = {
            type: 'array',
            items: {
              type: 'record',
              fields: field.subFields.map(sf => ({
                name: sf.name,
                type: sf.nullable !== false ? ['null', sf.type || 'string'] : (sf.type || 'string')
              }))
            }
          };
          if (field.nullable) avroType = [avroType, 'null'];
        } else if (field.type === 'array' && Array.isArray(valueCapture) && valueCapture.length > 0 && typeof valueCapture[0] === 'object' && valueCapture[0] !== null) {
          // Array sin subFields en la config, pero el valor real tiene objetos → inferir estructura dinámica
          const sampleItem = valueCapture[0];
          const inferredFields = Object.keys(sampleItem).map(key => ({
            name: key,
            type: ['null', 'string'] as any
          }));
          avroType = {
            type: 'array',
            items: {
              type: 'record',
              fields: inferredFields
            }
          };
          if (field.nullable !== false) avroType = [avroType, 'null'];
        } else {
          avroType = (field.nullable === true) ? [field.type, 'null'] : field.type;
        }
        disObject[fieldName] = this.sharedService.serializeAvroValue(avroType, valueCapture);
      }

      return this.safeJsonStringify(disObject);
    }));

    const firstItem = payload.selectedItems[0] || {};

    // Determinar matchkey a partir del payload.audit (puede ser string o array) o, si no existe,
    // usar el matchKey del primer item (comportamiento legacy).
    const auditMatchRaw = payload.audit && (payload.audit.matchkey ?? payload.audit.matchKey);
    let matchkeyValue: string | string[] = '';

    if (Array.isArray(auditMatchRaw)) {
      matchkeyValue = auditMatchRaw;
    } else if (typeof auditMatchRaw === 'string' && auditMatchRaw.length > 0) {
      matchkeyValue = auditMatchRaw;
    } else {
      matchkeyValue = firstItem.matchKey || '';
    }

    const finalAudit = {
      comentarios: payload.audit.comments,
      origen: payload.audit.origin,
      user: payload.audit.user,
      matchkey: matchkeyValue,
      document: firstItem.documento || firstItem.nationalId || '',
      fields: payload.audit.fields
    };

    const finalApiPayload: any = { data: dataArray, audit: finalAudit };

    // Agregar purposingProfiles si existe en el header y tiene elementos
    if (payload.header && payload.header.purposingProfileList &&
      Array.isArray(payload.header.purposingProfileList) &&
      payload.header.purposingProfileList.length > 0) {
      finalApiPayload.purposingProfiles = payload.header.purposingProfileList;
    }

    const objParams = { headers: this.getTokenToHeaders() };

    return this.modifyFuenteDinamica(currentCountry, currentSubDomain, finalApiPayload, objParams);
  }

  private safeJsonStringify(value: any): string {
    const jsonString = JSON.stringify(value, (_key, currentValue) => {
      if (typeof currentValue === 'bigint') {
        return `__BIGINT__${currentValue.toString()}__BIGINT__`;
      }
      return currentValue;
    });

    return jsonString.replace(/"__BIGINT__(\d+)__BIGINT__"/g, '$1');
  }

  modifyFuenteDinamica(country: string, subDomain: string, dataToSaveDIS: any, objParams: any): Observable<any> {
    // Obtener datos defensivamente desde getDataSourceSelected o valores por defecto
    const dataSourceSelected = (this.localStorageService.getDataSourceSelected || {}) as Menu;
    const { periods, domaine, periodsType, domainJO, subDomainJO } = dataSourceSelected;
    const isRds = this.localStorageService.esInternoRDS || this.localStorageService.getIsExternoRDS;

    // RDS mantiene su flujo propio (PATCH a rds-service)
    if (isRds) {
      const rutaMicroservicio = this.localStorageService.configInit["F_URL_MS_IM_RDS"];
      const urlBaseApi = (this.localStorageService.getIsVip)
        ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
        : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];
      const countryUrl = country.toLocaleUpperCase();
      const primaryKeyEncoded = encodeURIComponent(this.localStorageService.getPrimarykeyRds);
      const url = `${urlBaseApi}/${rutaMicroservicio}/${this.localStorageService.configInit["F_URL_DIS_BACK_GKL_V1"]}/${countryUrl}/${subDomain}/${primaryKeyEncoded}`;
      return this.http.patch<any>(url, dataToSaveDIS, objParams)
        .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
    }

    // DIS: determinar endpoint según formato del payload
    const domain = (periods && periodsType === 'situation') ? domaine : domainJO;
    const sub = (periods && periodsType === 'situation') ? subDomain : subDomainJO;

    if (dataToSaveDIS.newValues !== undefined) {
      // DIS Global v1: el payload tiene newValues → usar endpoint /global/
      console.log('[FuenteDinamicaService] modifyFuenteDinamica → DisService.postDisGlobal', { country, domain, sub });
      return this.disService.postDisGlobal(country.toUpperCase(), domain, sub, dataToSaveDIS);
    } else {
      // DIS v2: el payload tiene data[] → usar endpoint /DIS/ (legacy: creates, periods)
      console.log('[FuenteDinamicaService] modifyFuenteDinamica → DisService.postDis', { country, domain, sub });
      return this.disService.postDis(country.toUpperCase(), domain, sub, dataToSaveDIS);
    }
  }

  modifiedFields(dataBeforeMod: any, dataAfterMod: any) {
    let diffFields = [];

    // console.log('dataBeforeMod', dataBeforeMod);
    Object.keys(dataBeforeMod).forEach(key => {
      if ((dataAfterMod.value).hasOwnProperty(key)) {
        if (dataBeforeMod[key] !== dataAfterMod.value[key]) {
          diffFields.push(key);
        }
      }
    })
    return diffFields;
  }

  setCurrentPersons(person) {
    this.currentPersona = person;
  }

  getCurrentPersons() {
    return this.currentPersona;
  }

  updateDis(source: string, _form: FormGroup, dataToSave: any, service?: any): Observable<any> {
    if (environment.CONSUME_API_DATA.toString().toLowerCase() === "true") {
      const [domain, subdomain] = source.split('/');
      const country = this.localStorageService.getRegionSeleccionada?.getCode()?.toUpperCase() || 'AR';
      const payload = { data: dataToSave };
      console.log('[FuenteDinamicaService] updateDis → DisService.postDis', { country, domain, subdomain, service });
      return this.disService.postDis(country, domain, subdomain, payload);
    } else {
      return of({ "type": "mockResponse", "data": dataToSave });
    }
  }

  getRdsDataByCollection(collection: string) {
    const secondsTimeout = 10
    const clientTimeoutMs = secondsTimeout * 1000;
    const baseUrl = this.localStorageService.configInit["F_URL_BASE_API"];
    const rdsPath = this.localStorageService.configInit["F_URL_MS_IM_RDS"];
    const url = `${baseUrl}/${rdsPath}/api/v1/reference/collection/${collection}/data`;
    const httpParams = new HttpParams().set("timeout", secondsTimeout)
    const token = this.getTokenToHeaders();

    return this.http.get<any>(url, {
      headers: token,
      params: httpParams
    }).pipe(
      timeout(clientTimeoutMs),
      catchError((error: any) => {
        // console.log("EL ERROR DE LA PETICION: ", error)
        let errorMessage = "";

        if (error instanceof TimeoutError) {
          errorMessage = `La respuesta es muy grande para ser procesada en ${secondsTimeout} segundos Consulte a soporte.`;
        } else {
          switch (true) {
            case error.includes("408"):
              errorMessage = `La respuesta es muy grande para ser procesada en ${secondsTimeout} segundos. Consulte a soporte.`;
              break;
            case error.includes("400"):
              errorMessage = 'Se ha producido un error con su solicitud. Verifique que los datos ingresados sean válidos.';
              break;
            case error.includes("500"):
              errorMessage = 'Error interno del servidor. Por favor, contacte a soporte.';
              break;
            default:
              errorMessage = 'Error inesperado, contacte con el soporte';
              break;
          }
        }

        return throwError(() => ({ message: errorMessage, originalError: error }))
      }),
    )
  }

  getPurposing(baseUrl: string, country: string, domain: string, subdomain: string, entityKey: string, subDomainJo: string) {
    let rutaMicroservicio = "";
    const countryToUpper = country.toUpperCase();

    const params = new HttpParams().set('entityKey', entityKey);
    const objParams = { headers: this.getTokenToHeaders(), params: params };
    rutaMicroservicio = (environment.MICROSERVICIO.toString().toLowerCase() === "true" && !this.localStorageService.getIsVip)
      ? `${this.urlBaseApi}/${this.localStorageService.configInit["F_URL_MS_IM_JOURNALING"]}/api`
      : `${this.urlBaseApi}/vip/journaling-service`;

    const url = `${rutaMicroservicio}${baseUrl}/${countryToUpper}/${domain}/${subdomain ? subdomain : subDomainJo}`;
    console.log("URL --->", url)
    if (this.localStorageService.getIsVip) {
      // rutaMicroservicio = `${this.urlBaseApi}/vip/journaling-service`;
      const matrizVipField = this.localStorageService.dataEstructuraDinamicaHeader?.matrizVipField;

      let body: any = {
        'matriz': this.localStorageService.getMatrizArray
      };

      // Agregar el campo field si está configurado en el header
      if (matrizVipField) {
        body.field = matrizVipField;
      }
      console.log("paso por vip ---->");

      return this.http.post(url, body, objParams).pipe(
        timeout(Number(environment.HTTP_REQUEST_TIMEOUT)),
        map((data: any) => {
          this.setKeyingPurpusing(data, subDomainJo)
          return data;
        }),
        catchError(err => {
          return of([]);
        })
      );
    } else {
      return this.http.get(url, objParams).pipe(
        timeout(Number(environment.HTTP_REQUEST_TIMEOUT)),
        map((data: any) => {
          this.setKeyingPurpusing(data, subDomainJo)
          return data;
        }),
        catchError(err => {
          return of([]);
        })
      );

    }
  }

  setKeyingPurpusing(
    data,
    subDomainJo
  ) {
    try {
      if (data.hasOwnProperty('payload')) {
        let keying = data?.payload[subDomainJo][0].keying ?
          data.payload[subDomainJo][0].keying
          : null;

        if (keying.length > 0) {
          keying[0]["response"] = null;
        }


        this.keyingGkl = keying;
        this.keyingGklBackup = keying;
      }

    } catch (error) {
    }
  }

  /**
   * Obtiene los segmentos comunes del matchKey extrayendo valores directamente de los objetos.
   * Este método evita problemas con valores que contienen el separador (ej: emails con puntos)
   *
   * IMPORTANTE: Para lograr máxima robustez, este método debería recibir los 'fields' del matchKey
   * desde getMatchKey(). Sin embargo, dado que getMatchKey() es asíncrono, actualmente usamos
   * el método legacy getCommonMatchKeySegments() como fallback.
   *
   * MEJORA FUTURA: En el componente que llama a deleteFuenteDinamicaSource, primero obtener
   * los fields con getMatchKey() y pasarlos como parámetro adicional.
   *
   * @param objects - Array de objetos de datos con matchKey
   * @param country - Código del país
   * @param domain - Dominio
   * @param subdomain - Subdominio
   * @param separator - Separador de matchKey (por defecto '.')
   * @param matchKeyFields - Opcional: Array de nombres de campos que forman el matchKey
   * @returns String con los segmentos comunes del matchKey separados por el delimitador
   * @example
   * // Con fields (recomendado - robusto con emails):
   * getCommonMatchKeySegmentsFromObjects(
   *   [{ entityKey: 'ABC', email: 'user1@gmail.com', periodo: '202401' },
   *    { entityKey: 'ABC', email: 'user2@gmail.com', periodo: '202401' }],
   *   'AR', 'AR_CREDIT', 'BCRA_FINANCIAL_STATUS', '.',
   *   ['entityKey', 'email', 'periodo']
   * )
   * // Retorna: 'ABC' (solo entityKey es común)
   *
   * // Sin fields (fallback - puede fallar con puntos en datos):
   * getCommonMatchKeySegmentsFromObjects(
   *   [{ matchKey: 'ABC.user1@gmail.com.202401' },
   *    { matchKey: 'ABC.user2@gmail.com.202401' }],
   *   'AR', 'AR_CREDIT', 'BCRA_FINANCIAL_STATUS'
   * )
   * // Retorna: 'ABC' (funciona si no hay puntos en los valores)
   */
  private getCommonMatchKeySegmentsFromObjects(
    objects: any[],
    country: string,
    domain: string,
    subdomain: string,
    separator: string = '.',
    matchKeyFields?: string[]
  ): string {
    if (!objects || objects.length === 0) {
      return '';
    }

    if (objects.length === 1) {
      return objects[0].matchKey || '';
    }

    // Si tenemos los fields del matchKey, usamos el método robusto
    if (matchKeyFields && matchKeyFields.length > 0) {
      return this.getCommonMatchKeyFromFieldValues(objects, matchKeyFields, separator);
    }

    // Fallback: usar el método legacy con split (puede tener problemas con puntos en datos)
    console.warn(
      `[FuenteDinamicaService] getCommonMatchKeySegmentsFromObjects: ` +
      `No se proporcionaron matchKeyFields para ${domain}/${subdomain}. ` +
      `Usando método legacy que puede fallar si los valores contienen '${separator}' ` +
      `(ej: emails). Para mayor robustez, obtener los fields con getMatchKey() primero.`
    );
    return this.getCommonMatchKeySegments(objects.map(obj => obj.matchKey));
  }

  /**
   * Extrae los valores comunes del matchKey usando los nombres de los campos.
   * Este método es robusto y NO tiene problemas con valores que contengan el separador.
   *
   * @param objects - Array de objetos de datos
   * @param fields - Array de nombres de campos que forman el matchKey (en orden)
   * @param separator - Separador para unir los valores (por defecto '.')
   * @returns String con los valores comunes unidos por el separador
   * @example
   * getCommonMatchKeyFromFieldValues(
   *   [{ entityKey: 'ABC', email: 'test1@gmail.com', periodo: '202401' },
   *    { entityKey: 'ABC', email: 'test2@gmail.com', periodo: '202401' }],
   *   ['entityKey', 'email', 'periodo'],
   *   '.'
   * )
   * // Retorna: 'ABC' (solo entityKey tiene el mismo valor en todos los objetos)
   */
  private getCommonMatchKeyFromFieldValues(
    objects: any[],
    fields: string[],
    separator: string = '.'
  ): string {
    if (!objects || objects.length === 0 || !fields || fields.length === 0) {
      return '';
    }

    const commonValues: string[] = [];

    // Iterar por cada field en orden
    for (const field of fields) {
      const firstValue = objects[0][field];

      // Verificar si este field tiene el mismo valor en todos los objetos
      const isCommon = objects.every(obj => obj[field] === firstValue);

      if (isCommon && firstValue != null && firstValue !== '') {
        commonValues.push(String(firstValue));
      } else {
        // Si encontramos un field diferente, dejamos de buscar
        break;
      }
    }

    return commonValues.join(separator);
  }

  /**
   * Obtiene los segmentos comunes de un array de matchkeys usando split (método legacy)
   * @deprecated Usar getCommonMatchKeySegmentsFromObjects cuando sea posible
   * @param matchkeys - Array de matchkeys separados por puntos
   * @returns String con los segmentos comunes unidos por puntos
   * @example
   * getCommonMatchKeySegments([
   *   '1Et2lD2uvW7zBQcQ5k4a1Sg1fG42ENL2CmQP8JCnRfv+sJYM27rwO2v253NeeQ==.1yut2@gmail.com.NA',
   *   '1Et2lD2uvW7zBQcQ5k4a1Sg1fG42ENL2CmQP8JCnRfv+sJYM27rwO2v253NeeQ==.1212362@gmail.com.NA'
   * ])
   * // Retorna: '1Et2lD2uvW7zBQcQ5k4a1Sg1fG42ENL2CmQP8JCnRfv+sJYM27rwO2v253NeeQ=='
   */
  private getCommonMatchKeySegments(matchkeys: string[]): string {
    if (!matchkeys || matchkeys.length === 0) {
      return '';
    }

    if (matchkeys.length === 1) {
      return matchkeys[0];
    }

    // Dividir todos los matchkeys en segmentos
    const sep = this.localStorageService.dataEstructuraDinamicaHeader?.separator || '.';
    const allSegments = matchkeys.map(mk => mk.split(sep));

    // Encontrar la cantidad mínima de segmentos
    const minLength = Math.min(...allSegments.map(segments => segments.length));

    // Comparar segmento por segmento
    const commonSegments: string[] = [];

    for (let i = 0; i < minLength; i++) {
      const firstSegment = allSegments[0][i];

      // Verificar si este segmento es igual en todos los matchkeys
      const isCommon = allSegments.every(segments => segments[i] === firstSegment);

      if (isCommon) {
        commonSegments.push(firstSegment);
      } else {
        // Si encontramos un segmento diferente, dejamos de buscar
        break;
      }
    }

    return commonSegments.join(sep);
  }

  callRDS(subDomain: string, body: any, baseUrlfuente: string, currentCountry: string) {
    this.getCurrentPerson();

    const rutaMicroservicio = "/" + this.localStorageService.configInit["F_URL_MS_IM_RDS"];
    const urlBaseApi = (this.localStorageService.getIsVip)
      ? this.localStorageService.configInit["F_VIP_URL_BASE_API"]
      : this.localStorageService.configInit["F_PINGID_URL_BASE_API"];

    console.log("callRDS - URL Base API:", urlBaseApi);
    console.log("callRDS - Ruta Microservicio:", rutaMicroservicio);
    console.log("callRDS - Subdominio:", subDomain);

    const url = environment.IS_LOCAL === 'true' ? `assets/mock/${currentCountry.toLowerCase()}/rds/alternatekeys/${subDomain}.json` : `${urlBaseApi}${rutaMicroservicio}${baseUrlfuente}${currentCountry.toUpperCase()}/${subDomain}`;
    let returnApiData
    if (environment.IS_LOCAL === 'false') {
      const objParamsGklHash = {
        headers: this.getTokenToHeaders()
      };

      returnApiData = this.http.post<any>(
        url, body, objParamsGklHash
      ).pipe(
        timeout(Number(environment.HTTP_REQUEST_TIMEOUT)),
        map((data: any) => {
          if (data?.response[0]?.statusCode === 404) {
            this.notificationService
              .showError(data?.response[0]?.statusMessage)
            return null;
          } else {
            const payload = [data?.response[0]?.values];
            return payload;
          }
        }),
        catchError(err => {
          return of([]);
        })
      );
    } else {
      returnApiData = this.getMock(url);
    }

    return returnApiData;
  }

  getMock(url: string) {
    return this.http.get(url).pipe(
      timeout(Number(environment.HTTP_REQUEST_TIMEOUT)),
      catchError(err => {
        return of([]);
      })
    );
  }

}
